export default __webpack_public_path__ + "static/media/blue-thumb-up.c3b7b0e6.svg";